import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../supabaseClient'
import './GMDirectory.css'

export default function GMDirectory() {
  const navigate = useNavigate()
  const [gms, setGms] = useState([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')

  useEffect(() => {
    async function load() {
      const { data: { session } } = await supabase.auth.getSession()
      if (!session) { navigate('/login'); return }

      const { data } = await supabase
        .from('profiles')
        .select('full_name, property, created_at')
        .eq('role', 'gm')
        .order('full_name', { ascending: true })

      setGms(data || [])
      setLoading(false)
    }
    load()
  }, [navigate])

  const filtered = gms.filter(g =>
    (g.full_name || '').toLowerCase().includes(search.toLowerCase()) ||
    (g.property || '').toLowerCase().includes(search.toLowerCase())
  )

  if (loading) return (
    <div style={{ minHeight: '100vh', background: '#0D3B66', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <p style={{ color: '#A7D8F5', fontFamily: 'Georgia, serif', fontSize: '16px', fontStyle: 'italic' }}>Loading...</p>
    </div>
  )

  return (
    <div className="dir">
      <nav className="dir-nav">
        <span className="dir-nav-logo">VACATIA UNIVERSITY</span>
        <button className="dir-nav-back" onClick={() => navigate('/dashboard')}>← Back to dashboard</button>
      </nav>

      <header className="dir-header">
        <p className="dir-eyebrow">Curriculum 01: Branding</p>
        <h1 className="dir-title">Your Cohort</h1>
        <p className="dir-sub">{gms.length} General Managers enrolled across the Vacatia portfolio</p>
      </header>

      <main className="dir-main">
        <input
          className="dir-search"
          type="text"
          placeholder="Search by name or property..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />

        <div className="dir-grid">
          {filtered.map((gm, idx) => (
            <div key={idx} className="dir-card">
              <div className="dir-avatar">
                {(gm.full_name || 'G').charAt(0).toUpperCase()}
              </div>
              <div className="dir-info">
                <p className="dir-name">{gm.full_name || 'Unnamed'}</p>
                <p className="dir-property">{gm.property || 'No property listed'}</p>
              </div>
            </div>
          ))}
        </div>
      </main>

      <footer className="dir-footer">
        <p>Vacatia University &nbsp;·&nbsp; Est. 2026 &nbsp;·&nbsp; <em>Leave better than you arrived.</em></p>
      </footer>
    </div>
  )
}
